<template>
  <div class="w-100">
    <div
      :class="`${item.interviewCandidateStatusId === 3 ? 'cursor-pointer' : ''}`"
      @click="item.interviewCandidateStatusId === 3 ? clickDetail() : {}"
    >
      <article class="interview-list__item" @mouseleave="$refs['dropdownListItem-' + item.interviewCandidateId]?.hide()">
        <div class="interview-list__item-content">
            <div class="interview-list__column interview-list__column--name">
              <div class="rounded-image" v-if="item.smallPhoto">
                <b-img
                  :src="item.smallPhoto"
                  class="opacity-content"
                  rounded="circle"
                  width="67"
                  height="67"
                  blank-color="#777"
                />
              </div>
              <div v-else class="rounded-image">
                <span>{{ item.name?.[0] }}{{ item.surname?.[0] }}</span>
              </div>
              <div class="name-details">
                <p
                >
                  {{ item.name }} {{ item.surname }}
                </p>
                <div class="d-flex align-items-center gap-1 w-100 cursor-pointer position-relative">
                  <span
                  >
                    {{ item.email }}
                  </span>
                  <i
                    v-if="!copyMailStatus"
                    @click="(e) => copyCandidateMail(e, item.email)"
                    class="icon-copy"
                  />
                  <i
                    v-if="copyMailStatus"
                    class="icon-tick-rounded green-icon"
                  />
                </div>
              </div>
            </div>
            <div class="interview-list__column interview-list__column--status" v-if="interviewType === 1">
              <div v-if="item.interviewCandidateViewStatusId === 1"
                  class="interview-list__status completed"
                  v-b-tooltip.hover.bottom="{ customClass: 'candidate-list-tooltip' }"
                  :title="completedDate">
                <i class="icon-tick-rounded"></i>
                <p>{{ resource["candidateListItemCompletedText"]}}</p>
              </div>
              <div v-else-if="item.interviewCandidateViewStatusId === 2" class="interview-list__status scheduled">
                <p>{{ resource["candidateListItemScheduledText"]}}</p>
              </div>
              <div v-else-if="item.interviewCandidateViewStatusId === 3" class="interview-list__status sent">
                <i class="icon-tick-rounded"></i>
                <p>{{ resource["candidateListItemSentText"]}}</p>
              </div>
              <div v-else-if="item.interviewCandidateViewStatusId === 4" class="interview-list__status incomplete">
                <i class="icon-info"></i>
                <p>{{ resource["candidateListItemIncompleteText"]}}</p>
              </div>
              <div v-else-if="item.interviewCandidateViewStatusId === 5" class="interview-list__status expired">
                <i class="icon-info"></i>
                <p>{{ resource["candidateListItemExpiredText"]}}</p>
              </div>
            </div>
            <template v-if="interviewType === 1">
              <div class="interview-list__column interview-list__column--scheduling" v-if="showResendSchedule" @click="scheduleResendLink()">
                <div class="scheduling-container">
                  <div class="scheduling-dates"
                    v-b-tooltip.hover.bottom="{ customClass: 'candidate-list-tooltip' }"
                    :title="resource['candidateListItemScheduleTooltip']"
                  >
                    <span>{{ scheduleSentDate }}</span>
                    <span>{{ scheduleExpireDate }}</span>
                  </div>
                  <div class="edit-icon">
                    <i class="icon-edit-two" />
                  </div>
                </div>
              </div>
              <div class="interview-list__column interview-list__column--scheduling" v-else>
                <span>{{ scheduleSentDate }}</span>
                <span>{{ scheduleExpireDate }}</span>
              </div>
            </template>
            <div class="interview-list__column interview-list__column--counts" :style="countsColumnWidth ? `width:${countsColumnWidth}px` : ''">
              <div class="interview-list__count" v-if="interviewType === 1">
                <div class="interview-list__count-border" v-if="item.transcriptionStatus === 1 || item.transcriptionStatus === 2">
                  <i class="icon-schedule"></i>
                  <p>{{ resource["candidateTranscribingText"] }}</p>
                </div>
                <div class="interview-list__count-border" v-else-if="item.analyzeStatus === 1 || item.analyzeStatus === 2">
                  <i class="icon-schedule"></i>
                  <p>{{ resource["candidateAnalyzingText"] }}</p>
                </div>
                <div class="interview-list__count-content cursor-pointer" v-else-if="item.aiAnalyzeAverageRate" @click="(e) => goToAnalysis(e)">
                  <p>{{ item.aiAnalyzeAverageRate.toFixed(1) }}</p>
                  <img :src="getRateIconSvg(item.aiAnalyzeAverageRate)" width="16" height="16"/>
                </div>
                <b-button v-else-if="item.interviewCandidateStatusId === 3 && !item.aiAnalyzeAverageRate" :id="`analyze-${item.interviewCandidateId}`" name="analyzeBtn" @click="analyzeCandidateHandler($event)" :class="`gradient-border-button ${analyzeButtonLoading ? 'disabled' : ''}`">
                  <i class="icon-awesome-two" width="16" height="16" />
                  <span>{{ resource["interviewListItemAnalyzeBtn"] }}</span>
                </b-button>
                <span v-else-if="item.interviewCandidateStatusId !== 3">-</span>
              </div>
              <div class="interview-list__count cursor-pointer" v-if="interviewType === 1">
                <div class="interview-list__count-content" v-if="item.averageRate" @click="clickDetail()">
                  <p>{{ item.averageRate.toFixed(1) }}</p>
                  <img :src="getRateIconSvg(item.averageRate)" width="16" height="16"/>
                </div>
                <a
                  v-if="item.interviewCandidateStatusId === 3 && !item.averageRate"
                  class="border-button"
                  href="javascript:;"
                  @click="evaluateBtnHandler($event)"
                  >
                  <span>
                    {{ resource["candidateListItemEvaluateText"] }}
                  </span>
                </a>
                <span v-else-if="item.interviewCandidateStatusId !== 3">-</span>
              </div>
              <a
                v-if="interviewType !== 1"
                :class="`${item.interviewCandidateStatusId === 3 ? 'interview-list__status completed' : 'border-button'}`"
                href="javascript:;"
                @click="evaluateBtnHandler($event)"
                >
                <i class="icon-tick-rounded" v-if="item.interviewCandidateStatusId === 3"></i>
                <span>
                  {{ getAnswersButtonContent }}
                </span>
              </a>
            </div>
            <div class="interview-list__column interview-list__column--assigness" v-if="interviewType === 1 && showAssignees">
              <Assignees
                :key="`assignees-${item.interviewCandidateId}`"
                :id="`assignees-${item.interviewCandidateId}`"
                :assigned-evaluators="assignedUsers"
                :showTextButton="false"
                @addUser="setAssignUserToCandidate($event)"
                @removeUser="removeUserToCandidate($event)" :style="`z-index: ${zIndex};`"
                :canAssignEvaluator="canAssignEvaluator"
              />
            </div>
        </div>
        <div class="interview-list__item-actions dropdown-action cursor-pointer" v-if="interviewType === 1" @click="showActionMenuHandler(item.interviewCandidateId, $event)">
          <b-dropdown right no-caret :ref="`dropdownListItem-${item.interviewCandidateId}`" :id="`dropdownListItemId-${item.interviewCandidateId}`">
            <template #button-content>
              <i class="icon-more-vert"></i>
            </template>
            <b-dropdown-item v-if="item.interviewCandidateViewStatusId === 1 || item.interviewCandidateViewStatusId === 4" id="reactivateBtn" name="reactivateBtn" @click="() =>{ reactivateInterviewLink() }" ><i class="icon-tick-border" />{{resource["candidateListItemReactivateText"]}}</b-dropdown-item>
            <b-dropdown-item v-if="showResendSchedule" id="resendBtn" name="resendBtn" @click="() =>{ scheduleResendLink() }" ><i class="icon-resend" />{{resource["candidateListItemScheduleResendText"]}}</b-dropdown-item>
            <b-dropdown-item v-if="item.interviewCandidateViewStatusId === 3" id="resendBtn" name="resendBtn" @click="() =>{ resendLink() }" ><i class="icon-resend" />{{resource["candidateListItemResendText"]}}</b-dropdown-item>
            <b-dropdown-item id="copyCandidateInterviewLink" name="copyCandidateInterviewLink" @click="(e) => copyCandidateInterviewLink(e)" ><i class="icon-copy" />{{resource["candidateListItemCopyInterviewLinkText"]}}</b-dropdown-item>
            <b-dropdown-item v-if="item.interviewCandidateViewStatusId !== 1" id="deleteCandidate" name="deleteCandidate" @click="() =>{ deleteButtonHandler() }" ><i class="icon-delete-two" />{{resource["candidateListItemDeleteCandidateText"]}}</b-dropdown-item>
          </b-dropdown>
        </div>
      </article>
    </div>
    <div class="interview-list__divider" v-if="!lastChild" />
    <b-modal v-model="showDeleteModal" id="modal-center" centered hide-footer modal-class="new-modal">
      <div slot="modal-header" class="d-flex justify-content-between align-items-center w-100">
        <h2>{{ resource['deleteModalTitle'] }}</h2>
        <i class="icon-close custom-modal-close cursor-pointer" @click="showDeleteModal = false" />
      </div>
      <div class="d-flex align-items-center justify-content-center flex-column w-100">
        <p>{{ resource['deleteModalDescription'] }}</p>
        <div class="w-100 d-flex justify-content-end gap-3">
          <b-button
            name="cancel"
            class="border-button d-flex align-items-center mt-2"
            @click="showDeleteModal = false"
          >
            <span>{{ resource['deleteModalCancel'] }}</span>
          </b-button>
          <b-button
            name="updateStatusConfirm"
            class="bg-button gap-2 d-flex align-items-center mt-2"
            :disabled="deleteButtonLoading"
            @click="deleteButtonLoading ? {} : deleteCandidate()"
          >
            <span>{{ resource['deleteModalConfirm'] }}</span>
          </b-button>
        </div>
      </div>
    </b-modal>
    <div class="w-100">
      <b-modal v-model="showReactivateInterviewModal" id="modal-reactivate" centered :modal-class="`new-modal-reactivate ${resendLinkSuccessScreen ? 'new-modal-reactivate--auto-body' : ''}`" @hide="hideReactivateInterviewModal">
        <div slot="modal-header" class="d-flex justify-content-between w-100">
          <h2 v-if="!resendLinkSuccessScreen">{{ resource['reactivateInterviewModalHeaderTitle'] }}</h2>
          <h2 v-if="resendLinkSuccessScreen">{{ resource['resendModalHeaderTitle'] }}</h2>
          <i class="icon-close custom-modal-close cursor-pointer" @click="hideReactivateInterviewModal" />
        </div>
        <div class="first-screen" v-if="!showReactivateSuccessScreen">
          <div class="d-flex align-items-center justify-content-center flex-column w-100">
            <img src="/images/reactivate.svg" loading="lazy" alt="upgrade">
            <h2>{{ item.interviewCandidateViewStatusId === 4 ? resource['reactivateInterviewModalIncompleteTitle'] : resource['reactivateInterviewModalCompletedTitle'] }}</h2>
            <p>{{ item.interviewCandidateViewStatusId === 4 ? resource['reactivateInterviewModalIncompleteDescription'] : resource['reactivateInterviewModalCompletedDescription'] }}</p>
          </div>
          <div class="interview-checkbox-area" v-if="item.interviewCandidateViewStatusId === 4">
              <b-form-checkbox id="interview-checkbox" class="checkbox-2 checkbox-ats" v-model="continueAnswers">
                {{ resource['reactivateInterviewCheckboxDescription'] }}
              </b-form-checkbox>
          </div>
        </div>
        <div class="success-screen" v-else>
          <div class="d-flex align-items-center justify-content-center flex-column w-100" v-if="!resendLinkSuccessScreen">
            <img src="/images/reactivate.svg" loading="lazy" alt="upgrade">
            <h2>{{ resource['reactivatedModalTitle'] }}</h2>
            <p>{{ resource['reactivatedModalDescription'] }}</p>
          </div>
          <div class="d-flex align-items-center justify-content-center flex-column w-100" v-if="resendLinkSuccessScreen">
            <img src="/images/resend-email.svg" loading="lazy" alt="upgrade">
            <h2>{{ resource['resendModalTitle'] }}</h2>
            <p>{{ resource['resendModalDescription'] }}</p>
          </div>
          <div class="reactivate-link-area">
            <p>{{resource['reactivateModalOneSuccessLinkLabel']}}</p>
            <input type="text" :value="this.item.url" class="reactivate-link-area__input" readOnly />
            <div class="reactivate-link-area__button cursor-pointer" style="background: transparent !important;"
              @click="copyURL()">
              <svg v-if="!isCopy" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.9167 16.666H4.58335V5.83268C4.58335 5.37435 4.20835 4.99935 3.75002 4.99935C3.29169 4.99935 2.91669 5.37435 2.91669 5.83268V16.666C2.91669 17.5827 3.66669 18.3327 4.58335 18.3327H12.9167C13.375 18.3327 13.75 17.9577 13.75 17.4993C13.75 17.041 13.375 16.666 12.9167 16.666ZM17.0834 13.3327V3.33268C17.0834 2.41602 16.3334 1.66602 15.4167 1.66602H7.91669C7.00002 1.66602 6.25002 2.41602 6.25002 3.33268V13.3327C6.25002 14.2493 7.00002 14.9993 7.91669 14.9993H15.4167C16.3334 14.9993 17.0834 14.2493 17.0834 13.3327ZM15.4167 13.3327H7.91669V3.33268H15.4167V13.3327Z" fill="#FF8D06"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.32915 13.2305L4.43749 10.3388C4.11249 10.0138 3.58749 10.0138 3.26249 10.3388C2.93749 10.6638 2.93749 11.1888 3.26249 11.5138L6.74582 14.9971C7.07082 15.3221 7.59582 15.3221 7.92082 14.9971L16.7375 6.18047C17.0625 5.85547 17.0625 5.33047 16.7375 5.00547C16.4125 4.68047 15.8875 4.68047 15.5625 5.00547L7.32915 13.2305Z" fill="#49CA77"/>
              </svg>
            </div>
          </div>
        </div>
        <div slot="modal-footer" class="modal-footer">
          <div class="info-section" v-if="item.interviewCandidateViewStatusId === 4 && !showReactivateSuccessScreen">
            <i class="icon-info custom-modal-close cursor-pointer"></i>
            <span >{{ resource['reactivateInterviewModalInfo'] }}</span>
          </div>
          <div class="buttons-section">
            <b-button
              v-if="!resendLinkSuccessScreen"
              name="cancel"
              class="border-button"
              @click="hideReactivateInterviewModal"
            >
              <span>{{ resource['reactivateModalCancelBtn'] }}</span>
            </b-button>
            <b-button
              v-if="!showReactivateSuccessScreen"
              name="reactivateConfirm"
              class="bg-button gap-2 d-flex align-items-center"
              :disabled="reactivateButtonLoading"
              @click="reactivateButtonLoading ? {} : confirmReactivate()"
          >
              <span>{{ resource['reactivateModalActivateBtn']}}</span>
            </b-button>

            <b-button
              v-if="showReactivateSuccessScreen && !resendLinkSuccessScreen"
              name="reactivateResend"
              class="bg-button gap-2 d-flex align-items-center"
              @click="resendButtonLoading ? {} : resendInterview()"
            >
              <i class="icon-resend-border"/>
              <span>{{ resource['reactivateModalResendBtn'] }}</span>
            </b-button>
            <b-button
              v-if="resendLinkSuccessScreen"
              name="reactivateResend"
              class="bg-button gap-2 d-flex align-items-center"
              @click="hideReactivateInterviewModal"
            >
              <span>{{ resource['resendModalBackToListBtn'] }}</span>
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import hrvenueService from '../../../services/hrvenue.service';
import { showNotification } from '../../../static/helpers';
import Assignees from '../../common/Assignees.vue';

export default {
  name: 'InterviewCandidateCardItem',
  data() {
    return {
      copyMailStatus: false,
      analyzeButtonLoading: false,
      showDeleteModal: false,
      deleteButtonLoading: false,
      assignedUsers: [],
      showReactivateInterviewModal: false,
      reactivateButtonLoading: false,
      resendButtonLoading: false,
      continueAnswers: true,
      isCopy: false,
      showReactivateSuccessScreen: false,
      resendLinkSuccessScreen: false,
    };
  },
  props: {
    item: { type: Object, required: true },
    candidateId: { type: String, required: true },
    tab: { type: Number, required: false },
    showVideo: { type: Boolean, required: false, default: true },
    buttonContent: { type: String, required: false, default: 'Videoyu Oynat' },
    lastChild: { type: Boolean, required: true },
    zIndex: { type: Number, required: true },
    interviewType: { type: Number, required: true },
    showCheckbox: { type: Boolean, required: true },
    canAssignEvaluator: { type: Boolean, required: true },
    showAssignees: { type: Boolean, required: true },

    countsColumnWidth: {
      type: Number,
      default: null,
    },
    selectedCandidates: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Assignees,
  },
  watch: {
    'item.assignedEvaluators': {
      handler(newVal) {
        this.assignedUsers = newVal || [];
      },
      immediate: true,
    },
  },
  async created() {
    if (this.item.assignedEvaluators) {
      this.assignedUsers = this.item.assignedEvaluators;
    }
  },
  computed: {
    showResendSchedule() {
      return this.item.interviewCandidateViewStatusId === 2 || this.item.interviewCandidateViewStatusId === 3 || this.item.interviewCandidateViewStatusId === 5;
    },
    completedDate() {
      return this.$moment(
        this.item.completedDate,
      )
        .format('DD.MM.YYYY');
    },
    scheduleSentDate() {
      const date = `${this.item.sentDate}Z`;
      return this.$moment(
        date,
      )
        .format('DD.MM.YYYY');
    },
    scheduleExpireDate() {
      const date = `${this.item.expireDate}Z`;
      return this.$moment(
        date,
      )
        .format('DD.MM.YYYY');
    },
    getCandidateId() {
      if (this.candidateId) {
        return this.candidateId;
      }
      return this.item.candidateId;
    },

    getAnswersButtonContent() {
      if (this.interviewType !== 1 && this.item.interviewCandidateStatusId === 3) {
        return this.resource.candidateListItemEvaluatedText;
      }

      return this.resource.candidateListItemEvaluateText;
    },
  },
  methods: {
    hideReactivateInterviewModal() {
      this.showReactivateInterviewModal = false;
      this.showReactivateSuccessScreen = false;
      this.continueAnswers = false;
      this.reactivateButtonLoading = false;
      this.resendLinkSuccessScreen = false;
    },
    async resendInterview() {
      try {
        this.resendButtonLoading = true;
        const response = await hrvenueService.resendInterview(
          this.item.id,
        );

        if (response === true) {
          this.hideReactivateInterviewModal();
          showNotification(
            this.resource['label.Success'],
            this.resource.reactivateModalResendSuccessMessage,
            'success',
          );
        }
      } catch (error) {
        showNotification(
          this.resource['label.Error'],
          error.message,
          'error',
        );
      } finally {
        this.resendButtonLoading = false;
      }
    },
    copyCandidateMail(e, mail) {
      e.preventDefault();
      e.stopPropagation();
      if (!mail) return;
      navigator.clipboard.writeText(mail)
        .then(() => {
          this.copyMailStatus = true;
          setTimeout(() => {
            this.copyMailStatus = false;
          }, 3000);
        });
    },
    copyCandidateInterviewLink(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.item.url) return;
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'copy-interview-link',
        },
      });
      navigator.clipboard.writeText(this.item.url)
        .then(() => {
          showNotification(
            this.resource['label.Success'],
            this.resource.candidateListUrlCopySuccesMessage,
            'success',
          );
        }).catch(() => {
          showNotification(
            this.resource['label.Error'],
            this.resource.candidateListUrlCopyErrorMessage,
            'error',
          );
        });
    },

    deleteButtonHandler() {
      this.showDeleteModal = true;
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'delete',
        },
      });
    },
    async deleteCandidate() {
      //
      this.deleteButtonLoading = true;
      try {
        const response = await hrvenueService.deleteInterviewCandidate(this.item.id);
        if (response.body === true) {
          showNotification(
            this.resource['label.Success'],
            this.resource.candidateListDeleteSuccesMessage,
            'success',
          );
        }
        this.deleteButtonLoading = false;
        this.showDeleteModal = false;
        this.$emit('getCandidateListOfInterview');
      } catch (error) {
        showNotification(this.resource['label.Error'], error.message);
        this.deleteButtonLoading = false;
      }
    },
    scheduleResendLink() {
      this.showReactivateInterviewModal = false;
      this.showReactivateSuccessScreen = false;
      this.resendLinkSuccessScreen = false;
      this.$emit('scheduleResendLink', this.item);
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'schedule-resend',
        },
      });
    },
    async resendLink() {
      try {
        dataLayer.push({
          event: 'ga4_event',
          event_name: 'button_click',
          page_type: 'interview-detail',
          site_type: 'interview',
          event_parameters: {
            button_name: 'resend',
          },
        });
        this.resendButtonLoading = true;
        const response = await hrvenueService.resendInterview(
          this.item.id,
        );

        if (response === true) {
          this.showReactivateInterviewModal = true;
          this.showReactivateSuccessScreen = true;
          this.resendLinkSuccessScreen = true;
        }
      } catch (error) {
        showNotification(
          this.resource['label.Error'],
          error.message,
          'error',
        );
      }
    },
    analyzeCandidateHandler(event) {
      event.preventDefault();
      event.stopPropagation();
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'analyze',
        },
      });
      this.analyzeButtonLoading = true;
      this.$emit('showModalHandler', 'analyze', this.item);
      this.analyzeButtonLoading = false;
    },

    evaluateBtnHandler(event) {
      event.preventDefault();
      event.stopPropagation();
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'evaluate',
        },
      });
      this.clickDetail();
    },
    getRateIconSvg(rate) {
      const rateMappings = [
        { min: 0, max: 1, svgFile: require('@/assets/icon/0-1.svg') },
        { min: 1, max: 2, svgFile: require('@/assets/icon/1-2.svg') },
        { min: 2, max: 3, svgFile: require('@/assets/icon/2-3.svg') },
        { min: 3, max: 4, svgFile: require('@/assets/icon/3-4.svg') },
        { min: 4, max: 5, svgFile: require('@/assets/icon/4-5.svg') },
      ];

      const svgFile = rateMappings?.find((range) => rate > range.min && rate <= range.max)?.svgFile;

      return svgFile;
    },
    showActionMenuHandler(candidateId, event) {
      event.preventDefault();
      event.stopPropagation();
      this.$refs[`dropdownListItem-${candidateId}`].toggle();
    },
    handleCheckboxChange(isChecked, item) {
      item.isSelected = isChecked;
      this.$emit('itemSelected', item);
    },
    clickDetail() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;
      if (this.interviewType === 1) {
        dataLayer.push({
          event: 'ga4_event',
          event_name: 'button-click',
          page_type: 'interview-detail',
          site_type: 'interview',
          event_parameters: {
            button_name: 'response',
          },
        });
      }
      this.$router.push({
        name: 'CandidateDetailView',
        params: {
          interviewId: this.item.interviewId,
          interviewCandidateLogId: this.item.id,
          tab: this.tab,
          type: this.interviewType,
          switch: true,
          lang,
        },
      });
    },
    goToAnalysis(event) {
      event.preventDefault();
      event.stopPropagation();
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        page_type: 'interview-detail',
        site_type: 'interview',
        event_parameters: {
          button_name: 'analysis',
        },
      });
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;
      this.$router.push({
        name: 'CandidateDetailView',
        params: {
          interviewId: this.item.interviewId,
          interviewCandidateLogId: this.item.id,
          tab: this.tab,
          type: this.interviewType,
          switch: false,
          lang,
        },
      });
    },
    async setAssignUserToCandidate(user) {
      const response = await hrvenueService.assignEvaluatorToCandidate(
        this.item.id,
        [user.id],
      );
      if (response === true) {
        this.assignedUsers.push(user);
      }
    },
    async removeUserToCandidate(user) {
      const response = await hrvenueService.removeEvaluatorFromCandidate(
        this.item.id,
        user.id,
      );
      if (response === true) {
        this.assignedUsers = this.assignedUsers.filter(
          (evaluator) => evaluator.id !== user.id,
        );
      }
    },
    reactivateInterviewLink() {
      this.showReactivateInterviewModal = true;
    },
    async confirmReactivate() {
      this.reactivateButtonLoading = true;

      try {
        const response = await hrvenueService.reactivateCandidate(
          this.item.id,
          !this.continueAnswers,
        );

        if (response === true) {
          this.showReactivateSuccessScreen = true;
        }
      } catch (error) {
        showNotification(
          this.resource['label.Error'],
          error.message,
          'error',
        );
      } finally {
        this.reactivateButtonLoading = false;
      }
    },

    async copyURL() {
      if (!this.item) return;

      try {
        await navigator.clipboard.writeText(this.item.url);
        this.isCopy = true;
        setTimeout(() => {
          this.isCopy = false;
        }, 3000);
      } catch (error) {
        showNotification(
          this.resource['label.Error'],
          this.resource.copyLinkErrorMessage,
          'error',
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";
.border-purple {
  border: 1px solid #ff8d06 !important;
  background-color: #fff !important;
  border-radius: 5px !important;
}
.passive {
  border: 1px solid black;
  opacity: 0.5;
  cursor: not-allowed !important;
}
.fw-500 {
  font-weight: 500 !important;
}
.no-cursor {
  cursor: default !important;
}
.active-icon {
  path {
    fill: #fff;
  }
}

.stars {
  box-shadow: none;
  font-size: 12px !important;
  height: auto;
  min-height: auto;
  padding: 0 !important;
}

.star-empty {
  color: #cecece !important;
}

.rounded-image {
  display: flex;
  width: 40px;
  height: 40px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  border-radius: 96px;
  border: 1px solid #E5E5E5;
  background: #EEE;
  margin-right: 8px;

  span {
    color: #333;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-transform: uppercase;
  }
}

.rating-block {
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}

.rating-content {
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  border-radius: 8px;
  border: 0.5px solid #d4d4d4;
  background: #fafafa;
  height: 48px;

  span {
    color: #333;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  }
}

.basic-block {
  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    flex-direction: column;
    gap: 16px;
  }
}

.right-block {
  justify-content: center;
  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    align-items: flex-start;
  }
}

.bg-button {
  display: flex;
  padding: 9px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: #ff8d06;
  gap: 8px;

  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
}

.border-button {
  display: flex;
  padding: 9px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  border: 1px solid #D4D4D4;
  transition: all 0.2s ease-in-out;

  span {
    color: #333;
    text-align: center;
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 700 !important;
    line-height: 18px !important;
    padding: 0 8px;
  }

  i {
    width: 16px;
    height: 16px;
    margin-right: 0 !important;
  }

  &:hover {
    background: #E5E5E5;
  }

  &.passive {
    &:hover {
      background: transparent !important;
    }
  }
}

.card-badge-right {
  position: absolute;
  top: -1px;
  right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.card-badge-right-item {
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 2px;
  border: 1px solid #e4e4e4;
  border-top: 0;
  color: #aaa;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.info-block {
  word-break: break-all;

  &__name {
    color: #333;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
  &__email {
    color: #333;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto !important;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
}

.right-block {
  width: 340px;

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    width: 100%;
  }
}

.left-block {
  width: 340px;

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    width: 100%;
  }
}

::v-deep .dropdown-toggle {
  padding: 0;
  background: transparent !important;

  i {
    margin-right: 0;
  }
}

::v-deep .dropdown-action {
  .show {
    .btn {
      background: transparent !important;
    }
  }

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    position: absolute;
    top: 32px;
    right: 16px;
  }
}

::v-deep .dropdown-menu {
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  margin-right: 6px !important;
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 4px 0 !important;
  width: auto !important;
  min-width: 165px !important;
  margin-top: 8px !important;
  margin-right: 0 !important;
  left: 10px !important;

  li {
    &.disabled {
      cursor: not-allowed;
      pointer-events: all;
    }
  }

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    left: -40px !important;
  }
}
::v-deep .dropdown-item {
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  color: #353535 !important;
  padding: 6px 8px !important;
  transition: all 0.3s ease-in-out;
  display: flex;
  gap: 8px;
  align-items: center;

  &:hover {
    background: #EEE;
  }

  &.disabled {
    cursor: not-allowed;
    pointer-events: all;
  }
}

.candidate-list-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-right {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
      }
    }
  }

  &.bs-tooltip-left {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
        transform: rotate(180deg);
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 10px !important;

    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23E5E5E5"/></svg>') !important;
        width: 17px;
        height: 9px;
        bottom: 5px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    border: 1px solid var(--Stroke-Colors-Light-Blue-Stroke, #E5E5E5) !important;
    background: var(--Background-Colors-Light-Blue, #FFF) !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    width: fit-content !important;
    max-width: fit-content !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6) !important;

    text-align: left;
    color: var(--Text-Colors-Blue-Text, #333) !important;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
}
.interview-list__divider {
  width: calc(100% - 32px);
  height: 1px;
  background: #E5E5E5;
  margin: 0 16px;
}

.gradient-border-button {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  background-color: #fff;

  position: relative;
  z-index: 0;
  border: none;

  i {
    margin: 0;
    color: #FF8D06;
  }

  span {
    color: #333;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 700 !important;
    line-height: 20px !important;
    padding: 0 8px;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;  /* Kenarlık kalınlığı kadar iç boşluk */

    /* Kenarlık efekti için gradient tanımı */
    background: linear-gradient(var(--border-angle), #FF8D06, #FFC823, #6CF4E2);

    /* Merkezdeki iç kısım (içerik alanı) şeffaf kalsın diye maskeleme */
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;           /* Firefox vs. */
    -webkit-mask-composite: xor;       /* WebKit tabanlı tarayıcılar için */

    z-index: -1;            /* Kenarlık efekti butonun arkasında olsun */
  }

  &:hover {
    &::before {
      animation: gradient-rotate 2s linear infinite;
    }
  }

  &.disabled {
    &::before {
      background: #fff !important;
    }
    cursor: not-allowed;
    border: 1px solid #C3C3C3 !important;

    span,i {
      color: #C3C3C3 !important;
    }
  }
}

@property --border-angle {
  syntax: "<angle>";
  initial-value: 137deg;
  inherits: false;
}

@keyframes gradient-rotate {
  0% { --border-angle: 137deg; }
  100% { --border-angle: 497deg; } /* 137deg + 360deg to complete a full rotation without jumps */
}

::v-deep {
  .new-modal {
    .modal-dialog {
      max-width: 466px;
    }
    .modal-content {
      border-radius: 12px;
    }

    .modal-header {
      border-bottom: 0;
      padding: 12px 12px 12px 24px;
      border-bottom: 1px solid #E5E5E5; // Divider eklendi
      border-radius: 12px 12px 0px 0px !important;

      i {
        font-size: 24px;
        color: #333333;
      }
    }

    .modal-body {
      border-bottom: 0;
      padding: 0px 24px 24px 24px;

      img {
        margin-bottom: 14px;
      }

      h2 {
        color: #353535;
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 26px;
        margin-bottom: 8px;
      }

      p {
        color: #858585;
        font-feature-settings: "liga" off, "clig" off;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 24px;
        margin-top: 16px;
      }
    }

    .bg-button {
      display: flex;
      padding: 9px 8px;
      justify-content: center;
      align-items: center;
      border-radius: 114px;
      border: 1px solid #ff8d06;
      background: #ff8d06;
      transition: all 0.2s ease-in-out;
      width: fit-content;
      gap: 0 !important;
      margin-top: 12px;
      height: auto;

      span {
        color: #fff;
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
        padding: 0 8px;
      }

      i {
        font-size: 14px;
        margin-right: 0 !important;
      }

      &.disabled {
        border-color: transparent;
      }

      &:hover {
        background: #FF7415 !important;
      }

      @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
        width: 100%;
      }
    }

    .border-button {
      display: flex;
      padding: 9px 8px;
      justify-content: center;
      align-items: center;
      border-radius: 114px;
      border: 1px solid #ff8d06;
      background: transparent;
      transition: all 0.2s ease-in-out;
      height: auto;
      gap: 0 !important;

      span {
        color: #ff8d06;
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
        padding: 0 8px;
      }

      &.disabled {
        border-color: transparent;
      }

      &:hover {
        background: #ff8d06;
        color: #fff !important;

        span {
          color: #fff !important;
        }
      }
    }
  }
}
.interview-list__column--scheduling {
  display: flex;
  align-items: center;
  cursor: pointer;

  .scheduling-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .scheduling-dates {
    display: flex;
    flex-direction: column;
    justify-content: center;

    span {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .edit-icon {
    position: absolute;
    right: -16px; /* Sağ tarafa hizala */
    top: 50%; /* Yatay olarak ortala */
    transform: translateY(-50%); /* Tam ortalama */
    display: none; /* Varsayılan olarak gizli */
  }

  .scheduling-container {
    &:hover {
      .edit-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      span {
        text-decoration: underline;
      }
    }
  }

  .edit-icon i {
    color: #333333;
    font-size: 12px;
  }
}
::v-deep {
  .new-modal-reactivate {
    &--auto-body {
      .modal-body {
        height: auto !important;
        padding-bottom: 4px !important;

        @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
          height: 90% !important;
          max-height: 100%;
        }
      }
    }

    .modal-dialog {
      max-width: 601px;

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        width: 100%;
        max-width: 100% !important;
        margin: 0 !important;
      }
    }

    .modal-content {
      border-radius: 12px;

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        height: 100vh;
        border-radius: 0 !important;
      }
    }
    .modal-header {
      border-bottom: 1px solid #E5E5E5;
      border-radius: 12px 12px 0px 0px !important;
      padding: 16px 16px 16px 32px;

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        border-radius: 0 !important;
      }

      h2 {
        color: #333;
        font-family: 'Roboto';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
      }

      i {
        font-size: 24px;
        color: #333333;
      }
    }

    .modal-body {
      border-bottom: 0;
      padding: 0px 24px 0px 24px;
      height: 302px;

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 90% !important;
        max-height: 100%;
      }

      img {
        margin: 24px 0px 12px 0px;
      }

      h2 {
        color: #353535;
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 26px;
        margin-bottom: 8px;
      }

      p {
        color: #858585;
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .modal-footer {
      display: flex;
      padding: 16px 16px;
      justify-content: flex-end;
      align-items: center;
      width: auto;
      border-top: none;
      overflow: hidden;
      width: 100%;
      gap: 32px;
      flex-wrap: nowrap;

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        flex-direction: column;
        gap: 8px;
        border-radius: 0 !important;
      }

      .info-section {
        max-width: 337px;
        display: flex;
        align-items: flex-start;
        gap: 8px;

        i {
          display: flex;
          align-items: center;
          color: #858585;
          font-size: 16px;
          cursor: pointer;
        }
        span {
          font-family: Roboto;
          color: #878787;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
        }
      }

      .buttons-section {
        flex: 0 0 auto; // Sadece içeriği kadar yer kaplasın
        display: flex;
        gap: 8px;
        justify-content: flex-end;
      }
    }

    .bg-button {
      display: flex;
      padding: 9px 8px;
      justify-content: center;
      align-items: center;
      border-radius: 114px;
      border: 1px solid #ff8d06;
      background: #ff8d06;
      transition: all 0.2s ease-in-out;
      width: fit-content;
      height: auto;
      gap: 0 !important;

      span {
        color: #fff;
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
        padding: 0 8px;
      }

      i {
        font-size: 14px;
        margin-right: 0 !important;
      }

      &.disabled {
        border-color: transparent;
      }

      &:hover {
        background: #FF7415 !important;
      }

      @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
        width: 100%;
      }
    }

    .border-button {
      display: flex;
      padding: 9px 8px;
      justify-content: center;
      align-items: center;
      border-radius: 114px;
      border: 1px solid #ff8d06;
      background: transparent;
      transition: all 0.2s ease-in-out;
      height: auto;
      gap: 0 !important;

      span {
        color: #ff8d06;
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
        padding: 0 8px;
      }

      &.disabled {
        border-color: transparent;
      }

      &:hover {
        background: #ff8d06;
        color: #fff !important;

        span {
          color: #fff !important;
        }
      }
    }
  }
  .interview-checkbox-area {
    display: flex;
    padding: 12px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #E5E5E5 ;
    background: #FAFAFA;
    margin: 24px 16px;

    .custom-control-label {
      cursor: pointer;
      color: #333 !important;
      font-feature-settings: "liga" off, "clig" off;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px !important;
      padding: 2px !important;

      &:hover {
        &::after {
          background: #ffe9ce;
        }
      }
      &::after {
        border: 1px solid #333;
        border-radius: 2px;
        left: -20px;
      }
      &::before {
        border-color: transparent !important;
        outline: none;
        box-shadow: none;
        content: "";
        width: 16px !important;
        height: 16px !important;
      }
    }
    .custom-control-input {
      cursor: pointer;
      &:focus {
        border-color: transparent !important;
      }
      &:checked {
        & ~ .custom-control-label {
          &::before {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.86337 10.5836L3.55004 8.27026C3.29004 8.01026 2.87004 8.01026 2.61004 8.27026C2.35004 8.53026 2.35004 8.95026 2.61004 9.21026L5.39671 11.9969C5.65671 12.2569 6.07671 12.2569 6.33671 11.9969L13.39 4.94359C13.65 4.68359 13.65 4.26359 13.39 4.00359C13.13 3.74359 12.71 3.74359 12.45 4.00359L5.86337 10.5836Z" fill="white"/></svg>') !important;
            color: $white !important;
            background: $purple !important;
            font-size: 14px;
            text-align: center;
            position: absolute;
            left: -20px;
            border-radius: 2px;
          }
          &::after {
            display: none !important;
          }
        }
      }
    }
  }
  .reactivate-link-area {
      display: flex;
      flex-direction: column;
      align-self: center;
      position: relative;
      margin-top: 16px;
      font-family: 'Roboto' !important;
      width: 100%;

      p {
        color: var(--Text-Colors-Primary-Gray-Text, #333) !important;
        font-feature-settings: 'liga' off, 'clig' off;
        /* Typography/Subtitle/3 - Medium */
        font-family: Roboto;
        font-size: 14px !important;
        font-style: normal !important;
        font-weight: 500 !important;
        line-height: 20px !important;
        margin-bottom: 4px !important;
        text-align: left !important;
      }

      &__button {
        position: absolute;
        right: 8px;
        top: 32px;
        border: 0;
        color: #FF8D06;
        font-family: 'Roboto' !important;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.125rem;
      }

      &__input {
        width: 100%;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #C3C3C3;
        background: #FFF;
        padding: 0 8px;
        padding-right: 32px !important;
        font-family: 'Roboto' !important;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.125rem;
        color: #3A3A3A;

        &:focus {
          outline: none;
          border-color: #FF8D06 !important;
          box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
        }
      }
    }
}

</style>
